/* RESPONSIBLE TEAM: team-frontend-tech */
import { map } from '@ember/object/computed';
import { inject as service } from '@ember/service';
import Predicate from 'predicates/models/predicate';
import { readsAndFmtWithProperty } from '@intercom/pulse/lib/computed-properties';
import { IOS_VERSIONS } from 'predicates/models/data/ios';
import { CONVERSATION_RATINGS } from 'predicates/models/data/conversation-ratings';
export default Predicate.extend({
  appService: service(),
  genericType: 'numericSelect',
  isEditable: true,
  isNumericSelectType: true,
  defaultComparison: 'eq',
  goalComparison: 'eq',
  getDefaultValue() {
    return this.get('options.firstObject.value');
  },
  options: readsAndFmtWithProperty('%@Options', 'camelizedType'),
  androidAppVersionOptions: map('appService.app.android_app_versions', function (version) {
    return {
      label: version,
      value: version
    };
  }),
  androidVersionOptions: map('appService.app.android_os_versions', function (version) {
    return {
      label: version,
      value: version
    };
  }),
  iosAppVersionOptions: map('appService.app.ios_app_versions', function (version) {
    return {
      label: version,
      value: version
    };
  }),
  iosVersionOptions: IOS_VERSIONS,
  lastConversationRatingGivenOptions: CONVERSATION_RATINGS
});